export type ReactiveFormSubmitResultStatus =
    'skipped' |
    'validationError' |
    'warning' |
    'submitted' |
    'completed' |
    'failed';

export interface ReactiveFormSubmitResultSnapshot {
    readonly status: ReactiveFormSubmitResultStatus;
    readonly message?: string;
}

/** Builds small immutable submit-result snapshots for UI and contract tests. */
export class ReactiveFormSubmitResult {
    public static skipped(message?: string): ReactiveFormSubmitResultSnapshot {
        return ReactiveFormSubmitResult.create('skipped', message);
    }

    public static validationError(message?: string): ReactiveFormSubmitResultSnapshot {
        return ReactiveFormSubmitResult.create('validationError', message);
    }

    public static warning(message?: string): ReactiveFormSubmitResultSnapshot {
        return ReactiveFormSubmitResult.create('warning', message);
    }

    public static submitted(message?: string): ReactiveFormSubmitResultSnapshot {
        return ReactiveFormSubmitResult.create('submitted', message);
    }

    public static completed(message?: string): ReactiveFormSubmitResultSnapshot {
        return ReactiveFormSubmitResult.create('completed', message);
    }

    public static failed(message?: string): ReactiveFormSubmitResultSnapshot {
        return ReactiveFormSubmitResult.create('failed', message);
    }

    private static create(
        status: ReactiveFormSubmitResultStatus,
        message?: string,
    ): ReactiveFormSubmitResultSnapshot {
        if (message === undefined) {
            return { status };
        }

        return { status, message };
    }
}
